import React from 'react'
import LeftBanner from './LeftBanner';
import RightBanner from './RightBanner';
import HeroBackground from './HeroBackground';
import { useData } from '../../config/DataContext';
import { motion } from 'framer-motion';

const Banner = () => {
  const { portfolio } = useData();

  return (
    <>
      {portfolio.map((items, index) => (
        <motion.section
          key={index}
          id="home"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
          className="relative w-full pt-28 pb-8 flex flex-col gap-6 xl:gap-0 lgl:flex-row items-center min-h-[85vh]"
        >
          <HeroBackground />
          <div className="relative z-10 w-full flex flex-col gap-6 xl:gap-0 lgl:flex-row items-center">
            <LeftBanner user_data={items} />
            <RightBanner />
          </div>
        </motion.section>
      ))}
    </>
  );
}

export default Banner
